var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRightArrowTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 7.00003C0.875 6.84774 0.935497 6.70169 1.04318 6.594C1.15087 6.48631 1.29692 6.42582 1.44922 6.42582H11.0884L9.48057 4.93286C9.42527 4.88158 9.38062 4.81991 9.34915 4.75138C9.31768 4.68284 9.30002 4.60878 9.29718 4.53342C9.29434 4.45806 9.30637 4.38288 9.33258 4.31217C9.35879 4.24146 9.39867 4.1766 9.44995 4.1213C9.55351 4.00962 9.69719 3.94365 9.84938 3.93791C9.92474 3.93506 9.99993 3.94709 10.0706 3.9733C10.1414 3.99952 10.2062 4.0394 10.2615 4.09067L12.9412 6.57894C12.9992 6.63269 13.0454 6.69784 13.077 6.7703C13.1087 6.84276 13.125 6.92097 13.125 7.00003C13.125 7.07909 13.1087 7.15731 13.077 7.22977C13.0454 7.30222 12.9992 7.36737 12.9412 7.42112L10.2615 9.90939C10.1498 10.0129 10.0016 10.0679 9.84938 10.0622C9.69719 10.0564 9.55351 9.99045 9.44995 9.87876C9.34639 9.76708 9.29144 9.61884 9.29718 9.46664C9.30292 9.31445 9.36889 9.17076 9.48057 9.06721L11.0884 7.57425H1.44922C1.29692 7.57425 1.15087 7.51375 1.04318 7.40606C0.935497 7.29838 0.875 7.15232 0.875 7.00003Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowTime);
export default __webpack_public_path__ + "static/media/RightArrowTime.7d642ab59cdeaabc463019da864a4339.svg";
export { ForwardRef as ReactComponent };